import React, { useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useRecoilState } from 'recoil';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';

import Header from '../../../Public/Header/Header';
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import { userTabListState, userTabIndexState } from '../../../../core/store/UserStore';
import { useAuth } from '../../../../core/contexts/AuthContext';
import UserList from './UserList/UserList';
import UserDetail from './UserDetail/UserDetail';

// Manage > Users. A "Users" listing tab + (with edit permission) an "Add" tab, plus one detail tab
// per user drilled into.
const User = () => {
  const [userTabList, setUserTabList] = useRecoilState(userTabListState);
  const [tabIndex, setTabIndex] = useRecoilState(userTabIndexState);

  const { chkRolePermissions } = useAuth();

  // The "Add" tab/panel only renders with edit permission; the first detail tab sits right after it.
  const hasAddTab = chkRolePermissions("Manage", "User Details", "Edit");
  const detailBaseIndex = hasAddTab ? 2 : 1;

  //init Tab list when init
  useEffect(() => {
    setUserTabList([]);
    setTabIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userTabList.length < tabIndex - 1) {
      setTabIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userTabList, tabIndex]);

  const addTab = (item) => {
    const thisIndex = userTabList.findIndex((i) => i.UserId === item.UserId);

    if (thisIndex < 0) {
      setUserTabList([...userTabList, item]);
    } else {
      setTabIndex(thisIndex + detailBaseIndex);
    }
  };

  const removeTab = (removeItem) => {
    const filtered = userTabList.filter((i) => i.UserId !== removeItem.UserId);
    setUserTabList(filtered);
  };

  return (
    <ContentsWrapper header={<Header title="Users" />}>
      <div className="row no-gutters">
        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <Tabs
              forceRenderTabPanel={true}
              selectedIndex={tabIndex}
              onSelect={(index) => setTabIndex(index)}
            >
              <TabList>
                <Tab height="38"> Users</Tab>
                {hasAddTab && (
                  <Tab height="38">Add </Tab>
                )}
                {userTabList?.map((item) => (
                  <Tab key={item.UserId} height="38">
                    {item.UserCode}
                    <IconButton
                      aria-label="delete"
                      style={{ margin: "0 0 0 10px" }}
                      size="small"
                      onClick={() => removeTab(item)}
                    >
                      <CancelIcon fontSize="inherit" />
                    </IconButton>
                  </Tab>
                ))}
              </TabList>

              <TabPanel>
                <UserList addClaimTab={addTab} />
              </TabPanel>
              {hasAddTab && (
                <TabPanel>
                  <UserDetail item={null} tabOffset={detailBaseIndex} />
                </TabPanel>
              )}
              {userTabList?.map((item) => (
                <TabPanel key={item.UserId} header={item.UserCode}>
                  <UserDetail item={item} tabOffset={detailBaseIndex} />
                </TabPanel>
              ))}
            </Tabs>
          </div>
        </div>
      </div>
    </ContentsWrapper>
  );
};

export default User;
